export const MIN_INPUT_VALUE = 0;
export const MAX_INPUT_VALUE = 9999999;
